import { AssigneeType } from '@enums/assignee-type.enum';
import VisitsSection from './VisitsSection';
const PACIFIC = 'Pacific Time (US & Canada)';
const CENTRAL = 'Central Time (US & Canada)';
function makeVisit(overrides = {}) {
    return Object.assign({ id: 1, primary: false, assigneeType: AssigneeType.TECHNICIAN, technicianId: 1, subcontractorId: null, scheduledDate: '01/02/2027', scheduledTime: '09:00', timeZone: PACIFIC, duration: 120, priority: 'normal', priorityNote: '', visitNotes: '', techName: 'Drew Smith', canDelete: true }, overrides);
}
const baseArgs = {
    mode: 'form',
    visits: [makeVisit(), makeVisit({ id: 2, scheduledTime: '00:00', duration: 1439, techName: 'Mason Muszynski' })],
    subcontractorsEnabled: true,
    showPriority: true,
    timeZoneOptions: [
        { value: PACIFIC, label: '(GMT-08:00) Pacific Time (US & Canada)', iana: 'America/Los_Angeles' },
        { value: CENTRAL, label: '(GMT-06:00) Central Time (US & Canada)', iana: 'America/Chicago' }
    ],
    defaults: {
        technicianId: 1,
        subcontractorId: null,
        scheduledDate: '01/01/2027',
        timeZone: PACIFIC,
        timeZoneIana: 'America/Los_Angeles'
    },
    buildingId: null,
    series: null,
    endpoints: { checkAvailability: '/inspection_visits/check_availability' },
    inspectionId: null,
    canEdit: true
};
const meta = {
    title: 'Features/Inspections/Visits/VisitsSection',
    component: VisitsSection,
    args: baseArgs
};
export default meta;
export const FormMode = {};
export const ImmediateModeWithPrimary = {
    args: {
        mode: 'immediate',
        showPriority: false,
        inspectionId: 55,
        series: { frequencyLabel: 'Annual' },
        endpoints: {
            checkAvailability: '/inspection_visits/check_availability',
            create: '/inspection_visits',
            update: '/inspection_visits/:id',
            destroy: '/inspection_visits/:id'
        },
        visits: [
            makeVisit({ id: 10, primary: true, canDelete: false, scheduledTime: '14:00', techName: 'Padraic Doyle' }),
            makeVisit({ id: 11, techRole: 'Lead' })
        ]
    }
};
export const Empty = { args: { visits: [] } };
export const ReadOnly = { args: { canEdit: false } };
